<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="large-panel" style="height: 665px;" @click.stop>
                <div class="dialog-title" v-html="$t('message.title_bell_qr', { objectName: this.name })"></div>
                <hr class="dialog-hr" />

                <div class="dialog-body">
                    <table width="100%" cellpadding="0" cellspacing="0">
                        <div style="padding-left: 20px; padding-top: 15px; padding-bottom: 15px;">
                            <span style="color: #5ca244; font-size: 130%; font-weight: bold;" v-t="'message.info_bell_qr_notice'"></span>
                        </div>
                        <tr>
                            <td class="dialog-td">
                                <div class="inner-panel-header">
                                    <div class="inner-panel-title">
                                        <div class="inner-panel-title-left" v-t="'message.item_bell_qr_URL'">
                                        </div>
                                    </div>
                                </div>
                                <el-form style="padding: 20px 20px 0px;" :inline="true">
                                    <el-form-item>
                                        <el-input style="width: 650px;" id="bellURL" size="large" type="text"
                                            :value="bellURL" readonly />
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button style="vertical-align:middle" @click="copyBellURL()"
                                            v-t="'message.item_copy'" />
                                    </el-form-item>
                                    <el-form-item>
                                        <el-popconfirm :title="$t('message.info_bell_qr_refresh')"
                                            :confirmButtonText="$t('message.button_yes')"
                                            :cancelButtonText="$t('message.button_no')" icon="el-icon-info" iconColor="red"
                                            @onConfirm="refreshBellExternalId()">
                                            <el-button slot="reference" style="vertical-align:middle" native-type="button"
                                                v-t="'message.item_refresh_url'" />
                                        </el-popconfirm>
                                    </el-form-item>
                                </el-form>
                            </td>
                        </tr>
                        <tr>
                            <td class="dialog-td">
                                <div class="inner-panel-header">
                                    <div class="inner-panel-title">
                                        <div class="inner-panel-title-left" v-t="'message.item_bell_qr_QR'
                                            "></div>
                                    </div>
                                </div>
                                <template v-if="bellClientUrl && externalId">
                                    <figure class="qrcode">
                                        <img class="qrcode-img" :src="qrDataURL" />
                                    </figure>
                                </template>
                            </td>
                        </tr>
                    </table>
                </div>
                <hr class="dialog-hr" />
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('back')" v-t="'message.button_back'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import commonUtil from "./commonutil.js";
import constants from "./constants.js";
import server from "./ServerApi.js";
import QRCode from "qrcode"; // ダッシュボードベルとQRCodeのライブラリを統一

export default {

    props: {
        bellInfo: Object,
        bellClientUrl: String,
    },

    data() {
        return {
            name: null,
            externalId: null,
            qrDataURL: "",
        };
    },

    computed: {
        bellURL() {
            // URLセーフにする
            let encodedId = encodeURIComponent(this.externalId);
            const bellUrl = (this.bellClientUrl && encodedId) ? `${this.bellClientUrl}?id=${encodedId}` : "";
            // 非同期でQrCode用のURL作成
            QRCode.toDataURL(bellUrl, {
                width: 156,
                errorCorrectionLevel: 'M',
                margin: 4
            }, (err, dataUrl) => {
                if (err) {
                    console.error(err);
                    return;
                }
                this.qrDataURL = dataUrl;
            });
            return bellUrl;
        },
    },

    created() {
        this.name = this.bellInfo.name;
        this.getBellExternalId();
    },

    methods: {
        copyBellURL() {
            navigator.clipboard
                .writeText(this.bellURL)
                .then(() => {
                    commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n, "info_copied"));
                })
                .catch(e => {
                    commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "item_failed"));
                });
        },
        async getBellExternalId() {
            try {
                const res = await server.post("/getbellexternalid", { id: this.bellInfo.id });
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        this.externalId = res.data.externalId;
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "getbellexternalid").replace("{code}", res.data.status));
                        break;
                }
            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "getbellexternalid", e);
            }
        },
        async refreshBellExternalId() {
            try {
                const res = await server.post("/refreshbellexternalid", { id: this.bellInfo.id });
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        this.externalId = res.data.externalId
                        commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n, "info_bell_qr_refreshed"));
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "refreshBellExternalId").replace("{code}", res.data.status));
                        return;
                }
            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "refreshBellExternalId", e);
            }
        }
    }
};
</script>

<style scoped>
.qrcode {
    display: inline-block;
    font-size: 0;
    margin-bottom: 0;
    position: relative;
}
.qrcode-img {
    width: 300px;
}
</style>
